import { render, staticRenderFns } from "./couponDetail.vue?vue&type=template&id=00a5f71d&scoped=true"
import script from "./couponDetail.vue?vue&type=script&lang=js"
export * from "./couponDetail.vue?vue&type=script&lang=js"
import style0 from "./couponDetail.vue?vue&type=style&index=0&id=00a5f71d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a5f71d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00a5f71d')) {
      api.createRecord('00a5f71d', component.options)
    } else {
      api.reload('00a5f71d', component.options)
    }
    module.hot.accept("./couponDetail.vue?vue&type=template&id=00a5f71d&scoped=true", function () {
      api.rerender('00a5f71d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/promotion/couponDetail.vue"
export default component.exports